import React from 'react'
import { useState } from 'react';
import { FeedbackForm } from '../../components/feedbackPage/feedbackForm/FeedbackForm'
import styles from './feedback.module.css'
import { MarkupLayout } from '../../components/ui/markupLayout/MarkupLayout';
import { Thread } from '../../components/feedbackPage/thread/Thread';
import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { threadApi } from '../../api/threadQuery/threadApi';
import { commentsApi } from '../../module/comments/api/api';
import InfiniteScrollContainer from '../../components/infiniteScrollContainer/infiniteScrollContainer';
import { Loader } from '../../module/comments/components/loader/loader';
export function Feedback() {
    // const [isOpen, setIsOpen] = useState(false);
    // const { data, isLoading, isError } = useQuery({ ...threadApi.getThread() });
    const { data, fetchNextPage, isFetchingNextPage, hasNextPage } = useInfiniteQuery({ ...commentsApi.getThreads() });
    console.log(hasNextPage);

    return (
        <div >
            <MarkupLayout>
                <div className={styles.title}>Обратная связь</div>
                <div className={styles.feedback}>

                    <div className={styles.thread}>
                        <InfiniteScrollContainer onBottomReached={fetchNextPage}>
                            {data?.map((thread) => <Thread key={thread.id} thread={thread} />)}
                        </InfiniteScrollContainer>
                        {isFetchingNextPage && <div className={styles.loader} > <Loader></Loader></div>}
                    </div>
                    <FeedbackForm />

                </div>
            </MarkupLayout>
        </div>
    )
}
